export default ['ja', 'ko', 'zh', 'zh-hans']
